export default defineNuxtRouteMiddleware(() => {
  const now = new Date()
  const start = new Date(2026, 4, 29, 0, 0, 0, 0)
  const end = new Date(2026, 8, 1, 23, 59, 59, 999)

  if (now >= start && now <= end) {
    return navigateTo('/')
  }
})

